<template>
  <div>
    <div class="inner">
      <v-container fluid>
        <v-textarea
            @keyup.enter="createButton"
            outlined
            label="Type here the new JSON Button structure."
            v-model="navStructurePretty"
            rows="10"
        ></v-textarea>
        <v-btn @click="createButton" color="primary">create Button</v-btn>
      </v-container>
  
      <v-container fluid>
        <v-text-field
          v-model="menuTitleToDelete"
          @keyup.enter="deleteButton"
          color="error"
          label="Button name to be deleted"
        ></v-text-field>
        <v-btn @click="deleteButton" color="error">delete Button</v-btn>
      </v-container>
      <div class="feedback">
        <h5 v-if="!loading" v-bind:style="msgFeedbackColor">{{msg | prettyArray}}</h5>
        <v-progress-circular v-else :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navDebug",
  data: () => ({
    navStructure: "",
    menuTitleToDelete: "",
    msg: [],
    msgFeedbackColor: {
      color: "#FF5252"
    },
    loading: false
  }),
  computed: {
    navStructurePretty: {
      get: function() {
        try {
          return this.navStructure;
        } catch (e) {}
      },
      set: function(newValue) {
        try {
          this.navStructure = newValue;
        } catch (e) {}
      }
    }
  },
  methods: {
    async deleteButton() {
      this.msg.length = 0;
      this.loading = true;
      try {
        let res = await this.$store.dispatch("deleteNavStructureButton", {
          name: this.menuTitleToDelete
        });
        this.loading = false;
        this.msg.push("Button sucessfully deleted!");
      } catch (e) {
        console.log(e.response);
        this.loading = false;
        if (e.message === "Network Error") {
          this.msg.push("No connection to historical service API");
        } else {
          try {
            e.forEach(erro => {
              this.msg.push(erro.message);
            });
          } catch (e) {
            this.msg.push("Invalid sintaxe.");
          }
        }
      }
    },
    async createButton() {
      this.loading = true;
      this.msg.length = 0;
      try {
        let res = await this.$store.dispatch("createNavStructureButton", {
          structure: this.navStructure
        });
        this.loading = false;
        this.msg.push("Button sucessfully created!");
      } catch (e) {
        if (e.message === "Network Error") {
          this.msg.push("No connection to historical service API");
        } else {
          try {
            e.forEach(erro => {
              this.msg.push(erro.message);
            });
          } catch (e) {
            this.msg.push("Invalid sintaxe.");
          }
        }
        this.msgFeedbackColor.color = "#FF5252";
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.feedback {
  text-align: center;
}

.inner {
  width: 70%;
  margin: 0 auto;
}
</style>